import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Autoplay, Pagination, Scrollbar } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

import {
  CarouselContainer,
  SlideItem,
  SlideContent,
  Copy,
  BigTextWrapper
} from "./styled.components";

import { Message, MessageSections } from "../../../components/message/message";
import carouselImage1 from "../../../../assets/backgrounds/slider/carousel_1.jpg";
import carouselImage2 from "../../../../assets/backgrounds/slider/carousel_2.jpg";
import carouselImage3 from "../../../../assets/backgrounds/slider/carousel_3.jpg";
import BarekamButton, { ActionbarButtons } from "../../../components/button";
import BarekamText from "../../../components/text";
import { getMessage } from "../../../shared/helper-functions";
import { useAppSelector } from "../../../../redux/store";


const carouselItems = [
  {
    text: "carousel_text_1",
    buttonText: "carousel_button_1",
    buttonLink: '/login',
    image: carouselImage1
  },
  {
    text: "carousel_text_2",
    buttonText: "carousel_button_2",
    buttonLink: '/login',
    image: carouselImage2
  },{
    text: "carousel_text_3",
    buttonText: "carousel_button_3",
    buttonLink: '/login',
    image: carouselImage3
  }
]

const CustomCarousel: React.FC = () => {
  const navigate = useNavigate();
  const { language } = useParams();
  const { messageCache, languageId } = useAppSelector(
    (state) => state.messagesReducer,
  );

  return (
    <CarouselContainer>
      <SlideContent
        slidesPerView={1}
        pagination={{
          clickable: true,
        }}
        // autoplay={{ delay: 3000 }}
        parallax={true}
        speed={600}
        modules={[Autoplay, Pagination, Scrollbar]}
      >
        {carouselItems.map((item, index) => (
          <SlideItem key={item.image + index}>
            <Copy>
              <BigTextWrapper variant={"xxxl"} fontWeight={600} align={"left"} color="#2A2E3C" data-swiper-parallax="-300">
                <div dangerouslySetInnerHTML={{ __html: getMessage(item.text, MessageSections.LOGIN, messageCache, languageId) }} />
              </BigTextWrapper>
              <BarekamButton
                type={ActionbarButtons.NEW}
                size={"l"}
                onClick={() => navigate(`/${language}${item.buttonLink}`)}
                data-swiper-parallax="-200"
              >
                <BarekamText variant={"m"} fontWeight={500} align={"center"}>
                  <Message
                    messageKey={item.buttonText}
                    sectionId={MessageSections.LOGIN}
                  />
                </BarekamText>
              </BarekamButton>
            </Copy>
            <img src={item.image} alt={item.text} />
          </SlideItem>
        ))}
      </SlideContent>
    </CarouselContainer>
  );
};

export default CustomCarousel;
